
<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-card color="white" class="mb-2 pa-3">
      <v-card-text>
        <v-text-field v-model="client.client_credit_attributes.limit_aux" :rules="required"
          v-money="money" label="Limite de Crédito (R$)" prepend-icon="mdi-cash-multiple"></v-text-field>
        <v-text-field v-model="client.client_credit_attributes.blockingTime" :rules="required"
          label="Prazo para bloqueio" suffix="dias" type="tel" prepend-icon="mdi-calendar-clock"></v-text-field>
        <v-text-field v-model="client.lastSPC" label="Ultima consulta ao SPC"
          prepend-icon="mdi-cash-marker"></v-text-field>
        <div class="mt-2 mb-2">
          <input type="file" accept="application/pdf, image/*" style="display: none" id="file9" ref="file9"
            @change="handleFile()">
        </div>
      </v-card-text>
      <!-- <v-card-actions class="d-flex justify-center">
        <v-btn color="info" @click="$refs.file9.click()">Selecionar documento</v-btn>
      </v-card-actions> -->

      <!-- <v-col lg='12' v-if="file != ''" class="mt-2">
        <v-container v-if="client.fileSPC && file" grid-list-lg fluid class="pt-0 pb-0">
          <iframe v-if="client.fileSPC.type.includes('pdf') && !isMobile" :src="file" width="500"
            height="600"></iframe>
          <v-img v-if="client.fileSPC.type.includes('ima')" :src="file" contain></v-img>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{ client.fileSPC.name }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn text icon @click="removeFile()"> <v-icon small color="red">mdi-delete</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-container>
      </v-col> -->
      <v-col cols="12">
        <slot></slot>
      </v-col>
    </v-card>
    <v-btn text @click="emitChangeStepper(false)"><v-icon large color="red darken-2">mdi-arrow-up-bold</v-icon></v-btn>
    <f-btn save @click="emitChangeStepper(true)" :disabled="!valid"></f-btn>
  </v-form>
</template>

<script>
import { VMoney } from 'v-money'
import validations from "@/mixins/validations.js"

export default {
  name: 'ClientCreditsAndLimitStepper',
  directives: { money: VMoney },
  mixins:[ validations],
  props:{
    client:{
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      valid: true,
      file: '',
      money: {
        decimal: '.',
        thousands: ',',
        precision: 2,
        masked: true
      },
    }
  },
  methods: {
    validate(){
      return this.$refs.form.validate()
    },
    emitChangeStepper(increment){
      if(increment){
        this.client.client_credit_attributes.limit = parseFloat(this.client.client_credit_attributes.limit_aux.replace(/,/g, ''))
        this.client.client_credit_attributes.original_limit = parseFloat(this.client.client_credit_attributes.limit_aux.replace(/,/g, ''))
      }
      this.$emit("changeStepper", increment)
    },
    handleFile() {
      var uploadedFiles = this.$refs.file9.files
      this.client.fileSPC = uploadedFiles[0]

      var fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.file = fileReader.result
        this.client.attachment_attributes = {
          url_document: fileReader.result,
          name: this.client.fileSPC.name,
          kind: this.client.fileSPC.type,
        }
      })
      fileReader.readAsDataURL(this.client.fileSPC)
    },
    removeFile(i) {
      this.client.fileSPC = null
      this.file = ''
    },
  },
  computed:{
    isMobile() {
      if (document.body.clientWidth < 700 && this.client.fileSPC.size)
        return true
      else
        return false
    },
  },
}
</script>